import React, { useState } from 'react';
import { Spin, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import ToolButton from '../ToolButton/ToolButton';
import { PrintIcon } from '../ToolButton/icons';
import './printBoard.css';

const PrintBoard = () => {
    const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

    const handlePrint = useReactToPrint({
        content: () => document.getElementById('my-canvas-board'),
        onBeforeGetContent: () => {
            setIsGeneratingPreview(true);
            return new Promise((resolve) => {
                setTimeout(() => {
                    setIsGeneratingPreview(false);
                    resolve();
                }, 1000);
            });
        },
        onAfterPrint: () => { setIsGeneratingPreview(false); }
    });

    return (
        <>
            <ToolButton title="Print" onClick={handlePrint}><PrintIcon /></ToolButton>
            <Modal
                title="Generating preview"
                visible={isGeneratingPreview}
                closable={false}
                footer={null}
                width={240}
                centered
                className="print-preview-modal"
            >
                <div className="print-preview-modal__body">
                    <p>This may take a few moments</p>
                    <Spin indicator={<LoadingOutlined className="print-preview-modal__spinner" spin />} />
                </div>
            </Modal>
        </>
    );
};

export default PrintBoard;
